import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Fab, Typography } from '@mui/material';

// Icons
import { Close } from '@mui/icons-material';
import makeStyles from '@mui/styles/makeStyles';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  marginTop10: {
    marginTop: 10,
  },
  modalCloseButton: {
    float: 'right',
    marginTop: -6,
  },
  modalTitle: {
    minimumHeight: 50,
  },
}));

const CartRedirectionModal = ({ show, onClose, redirectLink, title, message }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const history = useHistory();

  const handleRedirect = useCallback(() => {
    history.push(redirectLink);
    onClose(true);
  }, [onClose, redirectLink, history]);

  const handleClose = useCallback(() => {
    onClose(false);
  }, [onClose]);

  if (!show) return null;

  return (
    <Dialog
      open={show}
      maxWidth={'lg'}
      fullWidth={true}
      onClose={handleClose}
      aria-labelledby="max-width-dialog-title"
      aria-describedby="modal-slide-description">
      <DialogTitle>
        <Fab size="small" className={classes.modalCloseButton} key="close" aria-label="Close" onClick={handleClose}>
          <Close className={classes.modalClose} />
        </Fab>
        <Typography variant="h1" sx={{ fontSize: { xs: 18, sm: 20, md: 24 } }}>
          {title}
        </Typography>
        <Divider className={classes.marginTop10} />
      </DialogTitle>
      <DialogContent id="modal-slide-description" className={classes.modalBody}>
        <span
          dangerouslySetInnerHTML={{
            __html: message,
          }}
        />
      </DialogContent>
      <DialogActions className={classes.modalFooter}>
        <Button onClick={handleRedirect} color="secondary" style={{ color: 'black', borderRadius: 0 }} variant="contained">
          <Typography variant="h1" sx={{ fontSize: { xs: 16, sm: 18, md: 22 } }}>
            {t('goToCart')}
          </Typography>
        </Button>
        <Button onClick={handleClose} color="primary">
          <Typography variant="h4">{t('keepShopping')}</Typography>
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default CartRedirectionModal;
